import React from 'react'

const SectionTitle = (props) => {
    return (
        <div className="row justify-content-center">
            <div className="col-lg-6 col-12">
                <div className="wpo-section-title">
                    <h2>How Can I Help?</h2>
                    <p>I specialize in software development, creating solutions using ASP.NET to deliver efficient, high-performance applications.</p>
                </div>
            </div>
        </div>
    )
}

export default SectionTitle;